import React, { useState } from "react";

interface ResultCardProps {
  title: string;
  content: string;
}

const ResultCard: React.FC<ResultCardProps> = ({ title, content }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  // Format content to put each numbered item on a new line
  const formatContent = (text: string): string => {
    if (!text || text.trim() === "") return "N/A";
    // Add a newline before each number followed by a period (except the first one)
    return text.replace(/\s+(\d+)\.\s+/g, "\n$1. ").trim();
  };

  const handleCopy = async () => {
    try {
      const textToCopy = formatContent(content);
      await navigator.clipboard.writeText(textToCopy);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  };

  const displayContent = formatContent(content);

  return (
    <div className="result-card">
      <div className="card-header">
        <div className="card-title-container">
          <h3 className="card-title">{title}</h3>
        </div>
        <button
          onClick={handleCopy}
          className={`copy-button ${copySuccess ? "copy-success" : ""}`}
          title="Copy to clipboard"
        >
          {copySuccess ? "✓" : "📋"}
        </button>
      </div>
      <div className="card-content">
        <pre className="content-text">{displayContent}</pre>
      </div>
    </div>
  );
};

export default ResultCard;
